const COINS = {
    COIN_BOUNCE_ANIMATION_DURATION: 1500,
    NUM_COINS: 3,
    MAX_TURNS: 6
};

export default COINS;
